import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractorJobsComponent } from './contractor-jobs/contractor-jobs.component';

const routes: Routes = [
  {
    path: '',
    component: ContractorJobsComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ContractorsRoutingModule { }
